import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./AuditTrail.module.css";
import { fetchAuditTrailListing, fetchActivityListing } from "../../redux";
import moment from "moment";
import ttmLoader from "../../assets/images/ttm-loader.gif";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD HH:mm:ss")
      ? moment(cell).format("YYYY-MM-DD HH:mm:ss")
      : moment(cell).format("YYYY-MM-DD HH:mm:ss")
  }`;
}

export class AuditTrail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      activity_id: 0,
      isDataFetched: false,
      auditTrailList: []
    };
    this.setLoader = this.setLoader.bind(this);
  }
  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <div>
        <Link>
          <i class="fa fa-pencil-square-o mr-3 relatedpartylist-edit-icon"></i>
        </Link>
        <a class="action-icons relatedpartylist-add-icon">
          <i class="fa fa-trash"></i>
        </a>
      </div>
    );
  }

  componentDidMount = async() => {
    document.title = 'Audit Trail - TechToMedix';

    await this.props.fetchActivityListing();
    
    await this.props.fetchAuditTrailListing(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page,
      this.state.activity_id
      );
      if(this.props.auditTrailListData && this.props.auditTrailListData.auditTrailList && 
        this.props.auditTrailListData.auditTrailList.auditLog){
        this.setState({
          auditTrailList: this.props.auditTrailListData.auditTrailList.auditLog
        })
      }

    setTimeout(() => {
      if (this.props.activityListData.activityList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);
  }

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }
  callAuditTrailAPI = async() => {
    this.setState({
      auditTrailList: []
    })
    await this.props.fetchAuditTrailListing(this.state.searchKey, this.state.sortBy, this.state.page, 
      this.state.activity_id);

      if(!this.props.auditTrailListData.loading){
        this.setState({
          auditTrailList: this.props.auditTrailListData.auditTrailList.auditLog
        })
        setTimeout(() => {
            this.setState({
              isDataFetched: true,
            });
        }, 3000);
      }

  }
  
  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callAuditTrailAPI();
    });
    
  };

  onSearchChange = (event) => {
    this.setState({ 
      searchKey: event.target.value, 
      page: 1, 
      isDataFetched: false 
    },()=>{
      this.callAuditTrailAPI();
    });
    
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ 
      page,
      isDataFetched: false 
    },()=>{
      this.callAuditTrailAPI();
    });
  };


  handleInputChange = (event) => {
    let filterval = event.target.value;

    this.setState({
      activity_id: filterval,
      page: 1,
      isDataFetched: false
    },()=>{
      this.callAuditTrailAPI();
    })
  }

  render() {
    const activityDropDownData = this.props.activityListData.activityList;
    const activityOptionsData =
      activityDropDownData.activity && activityDropDownData.activity.length > 0 &&
      activityDropDownData.activity.map((element, index) => (
        <option key={index} value={element.activity_id}>
          {element.activity}
        </option>
      ));
   // const auditTrailList = this.props.auditTrailListData.auditTrailList;

    return (
      <div className={style.auditTrailListMainWarapper}>
        <div>
          <div className="row">
            <div className="col-md-4">
              <h3>Audit Trail </h3>
            </div>

<div class="col-xl-8 order-3 order-md-2 d-flex flex-wrap  justify-content-start justify-content-md-end RelatedPartiesList_addRoleBtnWrapper__3C9uO">
            <div class="form-group mr-3">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />                  
                  </div>
                <div class="form-group">
                  <select
                    className="form-control"
                    id="activity_filter"
                    name="activity_filter"
                    onChange={this.handleInputChange}
                  >
                    <option value="0">All Activity</option>
                    {activityOptionsData}                
                  </select>
                </div>
                </div>
          </div>
          <div className="row">
                <div className="col-md-12">
                  <p>
                  The Audit Trail gives insights into the activities performed on the system. 
                  Activities such as System Login, Contact and Invoice Creation, the Logged in User etc. are logged. 
                  The log may be filtered by the activities performed.
                  </p>
                </div>
              </div>
          <BootstrapTable
            remote={true}
            bordered={false}
            data={this.state.auditTrailList}
            version="4"
            search={false}
            pagination
            fetchInfo={{
              dataTotalSize: this.props.auditTrailListData.auditTrailList.total,
            }}
            options={{
              searchvalue: "",
              sortName: this.state.sortName,
              sortOrder: this.state.sortOrder,
              onSortChange: this.onSortChange,
              onSearchChange: this.onSearchChange,
              sizePerPage: 10,
              page: this.state.page,
              onPageChange: this.onPageChange,
              noDataText: this.setLoader(),
            }}
          >
            <TableHeaderColumn
              isKey
              dataField="user_name"
              dataSort={true}
              width="22%"
            >
              User Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="role_name"
              dataSort={true}
              width="23%"
            >
              User Role
            </TableHeaderColumn>
            <TableHeaderColumn dataField="activity" dataSort={true} width="40%">
              Acitivity
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="created_at"
              dataSort={true}
              dataFormat={dateFormatter}
              width="20%"
            >
              Timestamp
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
      </div>
    );
  }
}

// export default Users;
const mapStateToProps = (state) => {
  return {
    auditTrailListData: state.auditTrailList,
    activityListData: state.activityList,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAuditTrailListing: (searchKey, sortBy, page, activity_id) =>
      dispatch(fetchAuditTrailListing(searchKey, sortBy, page, activity_id)),

    fetchActivityListing: () =>      dispatch(fetchActivityListing()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuditTrail);
